export const opacityStyle = {
  opacity: 0.6,
  transition: "0.3s ease-in-out",
};
export const clickableStyle = {
  cursor: "pointer",
  ...opacityStyle,
};
